import React, { useState, useEffect } from 'react';

export const FAQItem = props => {
  const { faq, index, isExpanded, toggleExpand, contentRef } = props;

  const [maxHeight, setMaxHeight] = useState('0px');

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (isExpanded) {
      setMaxHeight(`${el.scrollHeight}px`);
    } else {
      setMaxHeight('0px');
    }
  }, [isExpanded, contentRef]);

  return (
    <div key={index} className="contact-lens-faqs__question-container">
      <h5
        className="contact-lens-faqs__question-title"
        data-is-expanded={isExpanded ? 'true' : 'false'}
        onClick={() => toggleExpand(index)}
      >
        {faq.question}
      </h5>

      <div
        ref={contentRef}
        aria-hidden={!isExpanded}
        className="contact-lens-faqs__question__expanded-content"
        style={{
          maxHeight,
        }}
      >
        <p className="contact-lens-faqs__answer">{faq.answer}</p>

        {faq.link && (
          <div className="contact-lens-faqs__link-container">
            <a
              className="contact-lens-faqs__link-text"
              href={faq.link.url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {faq.link.text}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
